// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/governance/v0/semantic_types.proto (package squareup.governance.v0, syntax proto2)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { FieldOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Common_SemanticType } from "./common_pb";
import { file_squareup_common_governance_v0_common } from "./common_pb";
import type { ConsumerPersonalData_SemanticType } from "./consumer_personal_data_pb";
import { file_squareup_common_governance_v0_consumer_personal_data } from "./consumer_personal_data_pb";
import type { MerchantData_SemanticType } from "./merchant_data_pb";
import { file_squareup_common_governance_v0_merchant_data } from "./merchant_data_pb";
import type { PaymentCardData_SemanticType } from "./payment_card_data_pb";
import { file_squareup_common_governance_v0_payment_card_data } from "./payment_card_data_pb";
import type { EmployeePersonalData_SemanticType } from "./employee_personal_data_pb";
import { file_squareup_common_governance_v0_employee_personal_data } from "./employee_personal_data_pb";

/**
 * Describes the file squareup/common/governance/v0/semantic_types.proto.
 */
export const file_squareup_common_governance_v0_semantic_types: GenFile = /*@__PURE__*/
  fileDesc("CjJzcXVhcmV1cC9jb21tb24vZ292ZXJuYW5jZS92MC9zZW1hbnRpY190eXBlcy5wcm90bxIWc3F1YXJldXAuZ292ZXJuYW5jZS52MDpjCgZjb21tb24SHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGMhlIAMoDjIrLnNxdWFyZXVwLmdvdmVybmFuY2UudjAuQ29tbW9uLlNlbWFudGljVHlwZVIGY29tbW9uOnUKCGNvbnN1bWVyEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxjJZSADKA4yOS5zcXVhcmV1cC5nb3Zlcm5hbmNlLnYwLkNvbnN1bWVyUGVyc29uYWxEYXRhLlNlbWFudGljVHlwZVIIY29uc3VtZXI6bQoIbWVyY2hhbnQSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGMplIAMoDjIxLnNxdWFyZXVwLmdvdmVybmFuY2UudjAuTWVyY2hhbnREYXRhLlNlbWFudGljVHlwZVIIbWVyY2hhbnQ6ZgoDcGNpEh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxjLZSADKA4yNC5zcXVhcmV1cC5nb3Zlcm5hbmNlLnYwLlBheW1lbnRDYXJkRGF0YS5TZW1hbnRpY1R5cGVSA3BjaTp1CghlbXBsb3llZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYzGUgAygOMjkuc3F1YXJldXAuZ292ZXJuYW5jZS52MC5FbXBsb3llZVBlcnNvbmFsRGF0YS5TZW1hbnRpY1R5cGVSCGVtcGxveWVlQioKKGNvbS5zcXVhcmV1cC5wcm90b3MuY29tbW9uLmdvdmVybmFuY2UudjA", [file_google_protobuf_descriptor, file_squareup_common_governance_v0_common, file_squareup_common_governance_v0_consumer_personal_data, file_squareup_common_governance_v0_merchant_data, file_squareup_common_governance_v0_payment_card_data, file_squareup_common_governance_v0_employee_personal_data]);

/**
 * Common DSL Rubric
 *
 * @generated from extension: repeated squareup.governance.v0.Common.SemanticType common = 13000;
 */
export const common: GenExtension<FieldOptions, Common_SemanticType[]> = /*@__PURE__*/
  extDesc(file_squareup_common_governance_v0_semantic_types, 0);

/**
 * Consumer Personal Data
 *
 * @generated from extension: repeated squareup.governance.v0.ConsumerPersonalData.SemanticType consumer = 13001;
 */
export const consumer: GenExtension<FieldOptions, ConsumerPersonalData_SemanticType[]> = /*@__PURE__*/
  extDesc(file_squareup_common_governance_v0_semantic_types, 1);

/**
 * Merchant Data
 *
 * @generated from extension: repeated squareup.governance.v0.MerchantData.SemanticType merchant = 13002;
 */
export const merchant: GenExtension<FieldOptions, MerchantData_SemanticType[]> = /*@__PURE__*/
  extDesc(file_squareup_common_governance_v0_semantic_types, 2);

/**
 * Payment Card Data
 *
 * @generated from extension: repeated squareup.governance.v0.PaymentCardData.SemanticType pci = 13003;
 */
export const pci: GenExtension<FieldOptions, PaymentCardData_SemanticType[]> = /*@__PURE__*/
  extDesc(file_squareup_common_governance_v0_semantic_types, 3);

/**
 * Employee Personal Data
 *
 * reserved 13005 to 13999
 *
 * @generated from extension: repeated squareup.governance.v0.EmployeePersonalData.SemanticType employee = 13004;
 */
export const employee: GenExtension<FieldOptions, EmployeePersonalData_SemanticType[]> = /*@__PURE__*/
  extDesc(file_squareup_common_governance_v0_semantic_types, 4);

